export default __webpack_public_path__ + "static/media/undraw_add_information_j2wg.8c50ad5a.svg";